export const CREATE_PLAN_TEMPLATE_SUCCESS = 'CREATE_PLAN_TEMPLATE_SUCCESS';
export const LIST_PLAN_TEMPLATE_SUCCESS = 'LIST_PLAN_TEMPLATE_SUCCESS';
export const UPLOAD_FILES_TEMPLATE_SUCCESS = 'UPLOAD_FILES_TEMPLATE_SUCCESS';
export const DELETE_PLAN_TEMPLATE_SUCCESS = 'DELETE_PLAN_TEMPLATE_SUCCESS';
export const CLEAR_PLAN_TEMPLATE_STATE = 'CLEAR_PLAN_TEMPLATE_STATE';
export const UPDATE_PLAN_TEMPLATE_SUCCESS = 'UPDATE_PLAN_TEMPLATE_SUCCESS';
